import { ArrowRightIcon } from 'lucide-react';
import type { ComponentProps, FC } from 'react';
import { cn } from '../lib/utils';

type ChatSuggestionProps = Omit<ComponentProps<'button'>, 'type'>;

/** A prompt the user can pick instead of typing. */
export const ChatSuggestion: FC<ChatSuggestionProps> = ({
  className,
  children,
  ...props
}) => (
  <button
    type="button"
    className={cn(
      'group/suggestion flex w-full cursor-pointer items-center gap-2.5 rounded-lg border border-border bg-transparent px-3.5 py-[11px] text-left text-body leading-[1.125rem] text-[var(--z-text-secondary)] transition-colors duration-150 ease-standard hover:border-brand-border hover:bg-brand-subtle hover:text-foreground disabled:pointer-events-none disabled:opacity-40',
      className
    )}
    {...props}
  >
    <span className="flex-1 text-pretty">{children}</span>
    <ArrowRightIcon
      aria-hidden="true"
      className="size-[13px] shrink-0 text-muted-foreground transition-transform duration-150 ease-standard group-hover/suggestion:translate-x-0.5 group-hover/suggestion:text-brand"
    />
  </button>
);
